import React from 'react';

const hasText = (value) => typeof value === 'string' && value.trim() !== '';
const HALF_HOUR_STEP_EPSILON = 1e-9;

export const hasValidCertificateDetails = (value = {}) => {
  const hours = Number(value.horas);
  const doubledHours = hours * 2;
  const doubledHoursIsSafe =
    Number.isFinite(doubledHours) &&
    Math.abs(doubledHours) <= Number.MAX_SAFE_INTEGER;
  const followsHalfHourStep =
    doubledHoursIsSafe &&
    Math.abs(doubledHours - Math.round(doubledHours)) <=
      HALF_HOUR_STEP_EPSILON;

  return (
    hasText(value.capacitacion) &&
    hasText(value.fecha_capacitacion) &&
    Number.isFinite(hours) &&
    hours >= 0.5 &&
    followsHalfHourStep &&
    hasText(value.fecha_expedicion)
  );
};

export const CertificateDetailsStep = ({
  value = {},
  onChange,
}) => {
  const updateField = (field) => (event) => onChange(field, event.target.value);

  return (
    <section
      className="certificate-wizard-card"
      aria-labelledby="certificate-details-step-title"
    >
      <div className="certificate-wizard-card-heading">
        <span aria-hidden="true">2</span>
        <div>
          <h2 id="certificate-details-step-title">Datos de la constancia</h2>
          <p>Estos datos se compartirán entre todos los destinatarios.</p>
        </div>
      </div>

      <div className="certificate-wizard-details-grid">
        <div className="certificate-wizard-field certificate-wizard-field-wide">
          <label htmlFor="certificate-training">Capacitación</label>
          <input
            id="certificate-training"
            type="text"
            value={value.capacitacion || ''}
            onChange={updateField('capacitacion')}
            placeholder="Ejemplo: Derecho procesal"
            required
          />
        </div>
        <div className="certificate-wizard-field certificate-wizard-field-wide">
          <label htmlFor="certificate-training-period">
            Periodo de capacitación
          </label>
          <input
            id="certificate-training-period"
            type="text"
            value={value.fecha_capacitacion || ''}
            onChange={updateField('fecha_capacitacion')}
            placeholder="Ejemplo: 1 al 5 de agosto de 2026"
            required
          />
        </div>
        <div className="certificate-wizard-field">
          <label htmlFor="certificate-hours">Horas</label>
          <input
            id="certificate-hours"
            type="number"
            min="0.5"
            step="0.5"
            value={value.horas || ''}
            onChange={updateField('horas')}
            required
          />
        </div>
        <div className="certificate-wizard-field">
          <label htmlFor="certificate-expedition-date">
            Fecha de expedición
          </label>
          <input
            id="certificate-expedition-date"
            type="date"
            value={value.fecha_expedicion || ''}
            onChange={updateField('fecha_expedicion')}
            required
          />
        </div>
      </div>
    </section>
  );
};
